const inrFormatter = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const formatPrice = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return inrFormatter.format(n);
};

export const formatDate = (input) => {
  if (!input) return '';
  try {
    return new Date(input).toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return '';
  }
};

export const formatDateTime = (input) => {
  if (!input) return '';
  try {
    return new Date(input).toLocaleString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
};
